import MetaTags from "react-meta-tags";
import React from "react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Layout from "../flone/layouts";
import Breadcrumb from "../flone/wrappers/breadcrumb/Breadcrumb";
import { getMultiLangProperty } from "../helpers/generalHelper";

const BaseLayout = ({ children, breadcrumbsItems, title, metaTags }) => {
  const { i18n } = useTranslation();
  const storeConfig = useSelector((state) => state.storeConfig);
  const { siteTitle } = storeConfig || {};

  return (
    <>
      <MetaTags>
        <title>{title || getMultiLangProperty(siteTitle, i18n.language)}</title>
        {Array.isArray(metaTags) ? (
          metaTags.map((metaTag) => (
            <meta
              property={
                metaTag?.name || getMultiLangProperty(siteTitle, i18n.language)
              }
              content={
                metaTag?.content ||
                getMultiLangProperty(siteTitle, i18n.language)
              }
            />
          ))
        ) : (
          <meta
            property={getMultiLangProperty(siteTitle, i18n.language)}
            content={getMultiLangProperty(siteTitle, i18n.language)}
          />
        )}
      </MetaTags>
      {Array.isArray(breadcrumbsItems) &&
        breadcrumbsItems.map(({ label, to }, index) => (
          <BreadcrumbsItem key={`breadcrumbs_item_${index}`} to={to}>
            {label}
          </BreadcrumbsItem>
        ))}
      <Layout
        component="LayoutOne"
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
        headerTop="visible"
      >
        {Array.isArray(breadcrumbsItems) && <Breadcrumb />}
        {children}
      </Layout>
    </>
  );
};

export default BaseLayout;
